import * as React from 'react';

import { cn } from '@/shared/lib/utils';

interface DashboardGridProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Number of columns at the widest breakpoint. Defaults to 4. */
  cols?: 1 | 2 | 3 | 4 | 5;
}

/**
 * Responsive grid wrapper for KPI rows and chart rows.
 *
 * Use directly for KPI strips (e.g. `<DashboardGrid cols={4}>`) — chart
 * layouts that need uneven spans should compose `lg:tw-col-span-*` directly.
 */
export function DashboardGrid({
  cols = 4,
  className,
  children,
  ...rest
}: DashboardGridProps) {
  const breakpointMap: Record<NonNullable<DashboardGridProps['cols']>, string> = {
    1: 'tw-grid-cols-1',
    2: 'tw-grid-cols-1 sm:tw-grid-cols-2',
    3: 'tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3',
    4: 'tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4',
    5: 'tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-5',
  };

  return (
    <div className={cn('tw-grid tw-gap-4', breakpointMap[cols], className)} {...rest}>
      {children}
    </div>
  );
}
